import React, { useRef, useState } from 'react'

export default function FilterTable(props) {
  let [searchValue, setSearchValue] = useState("")

  let searchBySearch = (searchValue) => {
    if (props.originalList.length !== 0) {
      const matchResult = props.originalList.filter(obj => Object.values(obj).toString().toLowerCase().trim().replaceAll(" ", "").includes(searchValue.toLowerCase().trim().replaceAll("", "")))
      if (matchResult.length !== 0) {
        props.tempListMethod(matchResult)
      }
      else {
        props.tempListMethod([])
      }
    }
    else {
      props.tempListMethod([])

    }




  }
  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">

      {/* SEARCH */}
      {props.isSearch && (
        <div className="position-relative">
          <input
            type="search"
            className="form-control ps-5"
            placeholder="Search Here"
            onChange={(e) => searchBySearch(e.target.value)}
            style={{
              height: "38px",
              width: "200px",
              borderRadius: "10px",
              outline: "none",
              boxShadow: "none",
              border: "1px solid #e5e7eb"
            }}
            onFocus={(e) => {
              e.target.style.outline = "none";
              e.target.style.boxShadow = "none";
            }}
          />

          <i
            className="bi bi-search position-absolute"
            style={{
              top: "50%",
              left: "15px",
              transform: "translateY(-50%)",
              color: "#999"
            }}
          />
        </div>
      )}

      {/* DATE */}
      {props.isdate && (
        <div className="dropdown">
          <button
            className="btn d-flex align-items-center justify-content-between"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{
              height: "38px",
              width: "120px",
              borderRadius: "10px",
              border: "1px solid #e5e7eb",
              backgroundColor: "#fff",
              color: "#6b7280",
              fontSize: "14px"
            }}
          >
            Date
            <i className="bi bi-chevron-down ms-2"></i>
          </button>

          <ul
            className="dropdown-menu p-2"
            style={{ minWidth: "220px" }}
          >
            <li>
              <input
                type="date"
                className="form-control"
                onChange={(e) => console.log(e.target.value)}
              />
            </li>
          </ul>
        </div>
      )}


      {/* FILTER */}
      {props.isFilter && (
        <div className="position-relative">
          <select
            className="form-control ps-5"
            style={{
              height: "38px",
              width: "170px",
              borderRadius: "10px",
              outline: "none",
              boxShadow: "none",
              border: "1px solid #e5e7eb",
              appearance: "none",
              WebkitAppearance: "none",
              MozAppearance: "none"
            }}
            onFocus={(e) => {
              e.target.style.outline = "none";
              e.target.style.boxShadow = "none";
            }}
          >
            <option>Filter by Project</option>
            <option>Project A</option>
            <option>Project B</option>
          </select>

          <i
            className="bi bi-funnel position-absolute"
            style={{
              top: "50%",
              left: "15px",
              transform: "translateY(-50%)",
              color: "#999",
              pointerEvents: "none"
            }}
          />
        </div>
      )}
      {
        props.isdaterange === true ?
          <div className='date-range-filter'>
            <div >
              <label htmlFor='fromdate' className=' me-2'>From Date</label>
              <input type='date' name='fromdate' onChange={(e) => props.setFromDate(e.target.value)} className='form-input-box' style={{ height: "45px", width: "150px" }} />
            </div>
            <div>
              <label htmlFor='Todate' className=' me-2'>To Date</label>
              <input type='date' name='Todate' onChange={(e) => props.settoDate(e.target.value)} className='form-input-box' style={{ height: "45px", width: "150px" }} />
            </div>
          </div> : ''

      }

    </div>
  )
}
